function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "primary-fill primary-stroke",
  fill: "#434957",
  stroke: "#434957",
  strokeWidth: 0.2,
  d: "M15.458 1.955l-.942-1.01A2.073 2.073 0 0 0 11.59.843L2.502 9.317a.457.457 0 0 0-.124.194L.918 14.02a.46.46 0 0 0 .55.589l4.598-1.142a.46.46 0 0 0 .204-.11l9.086-8.474c.405-.377.638-.89.657-1.443a2.055 2.055 0 0 0-.555-1.484zm-9.73 10.647l-3.679.913 1.168-3.606 7.317-6.823 2.511 2.692-7.317 6.824zm9-8.393l-1.01.942-2.51-2.693 1.01-.942a1.153 1.153 0 0 1 1.626.057l.942 1.01a1.149 1.149 0 0 1-.057 1.626z"
});

const SvgIcPencil = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcPencil, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-pencil.eff3ed20.svg";
export { ForwardRef as ReactComponent };